import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router'
import './styles.scss';
import { checkHttpStatus, parseJSON } from '../../utils';
import { setCurrentSection } from '../../actions/globalConfig';

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gallery: null,
    };
    this.fetchGallery = this.fetchGallery.bind(this);
  }

  fetchGallery() {
    return fetch(`${SERVER_URL}/get_gallery_by_slug?gallery=${this.context.router.params.gallerySlug}`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        if (response.status === 'error') {
          browserHistory.push('/photos');
        }
        this.setState({ gallery: response.data });
        this.props.dispatch(setCurrentSection(response.data.title));
      })
      .catch((error) => {
        browserHistory.push('/photos');
        console.log(error, 'An error occurred');
        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  }

  componentWillMount() {
    this.fetchGallery();
    this.props.dispatch(setCurrentSection('Gallery'));
  }
  render() {
    const { gallery } = this.state;
    if (!gallery || !gallery.gallery_uri) return null;
    return (
      <iframe src={gallery.gallery_uri} className="gallery" />
    );
  }
}

Gallery.contextTypes = {
  router: PropTypes.object,
};

export default connect(null)(Gallery);
